<template lang='pug'>
div.modal-container
    div.content-modal
        h3.titulo-modal {{ $t('mensagens.menuMapa.territorio') }}:
        h5.texto-modal {{data.nomeTerritorio}}
    
    div.content-modal
        h3.titulo-modal {{ $t('mensagens.menuMapa.fornecedor') }}:
        h5.texto-modal N/A

    div.content-modal
        h3.titulo-modal {{ $t('mensagens.menuMapa.area') }}:
        h5.texto-modal {{data.areaTerritorio}} ha

    div.botao-modal
        BaseButton.botao-style(
            type='primary',
            @click='mudarRota(data.idTerritorio)'
        ) {{ $t('mensagens.menuMapa.realizarDiagnostico') }}
    
    div.botao-modal
        span.botao-link-style(
            @click='mudarRotaVisaoGeralFazenda(data.codigoFazenda)',
        ) {{ $t('mensagens.menuMapa.visualizarFazenda') }}

</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'PopupMapaRastreabilidade',

    components: {
        BaseButton
    },

    props: {
        mapa: {
            type: Object,
            required: true
        },

        data: {
            type: Object,
            required: true
        }
    },

    data() {
        return {};
    },

    methods: {
        mudarRota(id) {
            this.$router.push(`/territorio/socioambiental/${id}`);
        },

        mudarRotaVisaoGeralFazenda(id) {
            this.$router.push(`/raizen/rastreabilidade/visao-geral-fazenda/${id}`);
        }
    }
};
</script>

<style lang='scss' scoped>

.titulo-modal {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #3B3B3B;
}

.texto-modal {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3B3B3B;
}

.modal-container {
    flex: auto;
    flex-direction: column;
}

.content-modal {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 15px;
}

.botao-modal {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    padding-bottom: 15px;
}

.botao-style {
    width: 100%;
}

.botao-link-style {
    width: 100%;
    justify-content: center;
    align-self: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #114ADC;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
}

</style>
